import { createSlice } from "@reduxjs/toolkit";
import { addProductAPI } from "../../services/addProduct";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const addProductSlice = createSlice({
  name: "addProductDetails",
  initialState: data,
  reducers: {
    addProductSliceInfo(state) {
      state.isLoading = true;
    },
    addProductSliceInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    addProductSliceInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    addProductSliceInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const addProductHandler = (data) => async (dispatch) => {
  try {
    dispatch(addProductAction.addProductSliceInfo());
    const response = await addProductAPI(data);
    dispatch(addProductAction.addProductSliceInfoSuccess(response));
  } catch (e) {
    dispatch(addProductAction.addProductSliceInfoFailure(e));
  }
};
export default addProductSlice.reducer;
export const addProductAction = addProductSlice.actions;
